import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../static/images/didriksons_country_select.jpg'
import _imports_1 from '../../static/images/country_selector_logo.svg'
import _imports_2 from '../../static/icons/country-switcher-white-cart-icon.svg'
import _imports_3 from '../../static/icons/country-switcher-cart-icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "country-selector-layout"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "country-selector-layout__shadow" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "country-selector-layout__image",
  src: _imports_0,
  loading: "lazy"
}, null, -1)
const _hoisted_4 = { class: "country-selector-layout__form" }
const _hoisted_5 = { class: "country-selector-layout__form-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "country-selector-layout__logo",
  src: _imports_1
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "country-selector-layout__text" }, " The Swedish jacket brand since 1913 ", -1)
const _hoisted_8 = { class: "country-selector-layout__selected" }
const _hoisted_9 = {
  key: 0,
  class: "country-selector-layout__selected-country-icon",
  src: _imports_2
}
const _hoisted_10 = { class: "country-selector-layout__country" }
const _hoisted_11 = { class: "country-selector-layout__currency" }
const _hoisted_12 = { class: "country-selector-layout__option" }
const _hoisted_13 = {
  key: 0,
  class: "country-selector-layout__option-country-icon",
  src: _imports_2
}
const _hoisted_14 = {
  key: 1,
  class: "country-selector-layout__option-country-icon",
  src: _imports_3
}
const _hoisted_15 = {
  key: 2,
  class: "country-selector-layout__no-country-icon"
}
const _hoisted_16 = { class: "country-selector-layout__option-country" }
const _hoisted_17 = { class: "country-selector-layout__option-currency" }

import { ref, computed, watch, inject } from 'vue';
import { setMeta, setItemKey } from '@drapejs/core';

import { buildUrlPathWithQuery, setPrefferedCountryCookie } from '../../utils';

import useContext from '@/composables/useContext';
import useCountrySwitch from '@/composables/useCountrySwitch';

import Dropdown from '../forms/Dropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelectorLayout',
  setup(__props) {

const { route } = useContext();
const { availableCountries, geoIpCountryCode } = useCountrySwitch();

const setItem = inject(setItemKey);

const currentCountryId = ref('');

const countryOptions = computed(() => {
  const channels = [...(availableCountries.value || [])];
  return channels
    .map((c) => {
      const r = { ...c };
      r.value = c.channelSystemId + c?.countryId;
      r.countryId = c?.countryId;
      r.text = (c.name || '').trim();
      return r;
    })
    .filter((c) => c.rootPath);
});

const currentChannel = computed(
  () =>
    countryOptions.value.find((c) => c.value === currentCountryId.value) ||
    countryOptions.value[0]
);

const hasAnyCountries = computed(
  () => (availableCountries.value || [])?.length > 0
);

const isExpanded = ref(false);

function setExpanded(expanded) {
  isExpanded.value = expanded;
}

function changeCountry() {
  if (!currentChannel.value) {
    return;
  }

  const otherChannels = countryOptions.value.find(
    (c) =>
      c.channelSystemId === currentChannel.value.channelSystemId &&
      c.countryId !== currentChannel.value.countryId
  );

  let url = `//${currentChannel.value.rootPath}/`;
  let query = route.query || {};
  if (otherChannels) {
    query.country = currentChannel.value.countryId;
  }

  const redirectUrl = buildUrlPathWithQuery(url, query);
  setPrefferedCountryCookie(currentChannel.value.countryId);

  window.location.assign(redirectUrl);
}

setMeta(() => {
  const result = {
    title: 'Didriksons® | Select country',
  };

  return result;
});

watch(
  () => availableCountries.value,
  () => {
    if (geoIpCountryCode.value) {
      const channel = countryOptions.value?.find(
        (c) => c.countryId === geoIpCountryCode.value
      );
      if (channel) {
        currentCountryId.value = channel.channelSystemId + channel.countryId;
      }
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_unref(hasAnyCountries))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(Dropdown, {
              options: _unref(countryOptions),
              modelValue: currentCountryId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentCountryId).value = $event)),
              onExpanded: setExpanded,
              class: "country-selector-layout__dropdown"
            }, {
              selected: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_8, [
                  (slotProps.selected.supportsEcommerceFeatures)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(slotProps.selected.text), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(slotProps.selected.currencyId), 1)
                ])
              ]),
              option: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_12, [
                  (
                  slotProps.option.supportsEcommerceFeatures &&
                  slotProps.isSelected
                )
                    ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                    : _createCommentVNode("", true),
                  (
                  slotProps.option.supportsEcommerceFeatures &&
                  !slotProps.isSelected
                )
                    ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                    : _createCommentVNode("", true),
                  (!slotProps.option.supportsEcommerceFeatures)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(slotProps.option.text), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(slotProps.option.currencyId), 1)
                ])
              ]),
              _: 1
            }, 8, ["options", "modelValue"]),
            _createElementVNode("button", {
              class: _normalizeClass(["primary-button country-selector-layout__button", { 'country-selector-layout__button--hidden': isExpanded.value }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeCountry()))
            }, " Enter ", 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})